export default {
  Available: 0,
  Coordinated: 1,
  Cancelled_De: 2,
  Cancelled_Prov: 3,
  Completed: 4,
  Denied: 6,
  Extended: 8,
  Confirmed: 9,
};
